<template>
        <a-card :title="c_title">
            <a-form-model :model="modalState" ref="ruleForm" :rules="rules" :layout="formItemLayout"
                :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-form-model-item ref="appcode" label="所属应用" prop="appcode">
                    <a-input v-model="modalState.appcode" placeholder="点击选择应用编码" @click="handleSelecter"
                        v-if="!modalState.id"></a-input>
                    <span v-else>{{modalState.appcode}}</span>
                    <AppSelecter :modalState="selecterState" @onModalHide="onAppselecterHide"></AppSelecter>
                </a-form-model-item>

                <a-form-model-item ref="configitem" label="配置项" prop="configitem">
                    <a-input v-model="modalState.configitem" @blur="
                        () => {
                            $refs.configitem.onFieldBlur();
                        }
                        " />
                </a-form-model-item>

                <a-form-model-item label="配置参数" prop="configvalue">
                    <editor v-model="modalState.configvalue" @init="editorInit" :lang="currentLanguage" theme="monokai" width="100%"
                        height="400" style="font-size:15px;"></editor>
                </a-form-model-item>
                <a-form-model-item label="备注" ref="remark" prop="remark" :labelCol="labelCol" :wrapperCol="wrapperCol"
                    style="width:100%;margin-top:10px;">
                    <a-input v-model="modalState.remark" type="textarea" @blur="() => {
                                $refs.remark.onFieldBlur();
                            }
                            " />
                </a-form-model-item>

                <a-form-model-item :wrapper-col="{ span: 14, offset: 14 }">
                    <a-button type="primary" @click="handleOk">
                        保存
                    </a-button>
                    <a-button style="margin-left: 10px;" @click="handleCancel">
                        取消
                    </a-button>
                </a-form-model-item>
            </a-form-model>
        </a-card>
</template>
<script>
import AppSelecter from '@/components/AppSelecter'
import Editor from 'vue2-ace-editor'
import CONFIG from '@/common/config.js';

import {
    check_string_type,
    string_to_wrap
} from "@/utils/data_format_utils";
export default {
    data() {
        return {
            c_title:'编辑',
            labelCol: { span: 4 },
            wrapperCol: { span: 20 },
            currentLanguage:'xml',
            labelCol2: { span: 9 },
            wrapperCol2: { span: 15 },
            rules: {
                appcode: [
                    { required: true, message: '请选择所属app', trigger: 'blur' },
                ],

                configitem:[
                    { required: true, message: '请输入应用英文简称', trigger: 'blur' },
                ],
                configvalue:[
                    { required: true, message: '请输入应用中文简称', trigger: 'blur' },
                ],
            },
            confirmLoading: false,
            formItemLayout:'horizontal',
            selecterState:{
                isShow:false,
                rowsType:'radio' // or 'checkbox'，单选或多选
            },
            modalState:{
                id:'',
                appcode:'',
                appenv:'',
                configitem:'',
                configvalue:'',
                configtype:'02',
                remark:''
            }
        };
    },
    components:{
        AppSelecter,
        Editor
    },
    computed: {

    },
    methods: {

        editorInit() {
            // require('brace/ext/language_tools') //language extension prerequsite...
            require('brace/mode/xml')
            require('brace/mode/json')
            require('brace/mode/javascript')    //language
            require('brace/mode/less')
            require('brace/theme/monokai')
            require('brace/snippets/javascript') //snippet
        },
        onAppselecterHide(result){
            console.log(result)
            if(result == undefined){
                this.selecterState.isShow = false;
                return;
            }
            if(result.length > 0){
                this.modalState.appcode = result[0].appcode;
                this.modalState.syscode = result[0].syscode;
            }
            this.selecterState.isShow = false;
        },
        handleSelecter(){
            this.selecterState.isShow = true;
        },
        handleOk() {
            let appenv = "";
            if(CONFIG.API_HOST.indexOf('fp').length != -1){
                appenv = this.searchEnv = CONFIG.API_HOST.split('.')[0].replace('fp','')
            }
            else{
                appenv = 'dev'
            }
            this.modalState.appenv = appenv;
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.confirmLoading = true;
                    console.log(this.modalState);
                    if(this.modalState.id){
                        //编辑
                        this.$store
                            .dispatch({
                                type: "configcenter/editFile",
                                params: this.modalState
                            })
                            .then((response) => {
                                console.log(response)

                                this.handleCancel();
                                this.confirmLoading = false;
                            });
                    }
                    else{

                        //新增
                        this.$store
                            .dispatch({
                                type: "configcenter/addFile",
                                params: this.modalState
                            })
                            .then((response) => {
                                console.log(response)
                                if(response.data.success == '1'){
                                    this.handleCancel();
                                }
                                this.confirmLoading = false;


                            });
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },

        handleCancel() {
            this.$router.back(-1);
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },

    },
    mounted(){
        const {query} = this.$route;
        if(query.id){
            this.c_title = "编辑配置"
            let c_params = {}
            c_params.page = 1;
            c_params.pageSize = 10;
            c_params.urlparams = false;
            c_params.id = query.id;
            this.$store.dispatch({
                type: "configcenter/selectMidFile",
                params:c_params
            }).then((res)=>{
                this.tLoading = false;
                let result = res.data.data.list;
                console.log(result)
                if(result.length > 0){
                    result = result[0]
                    this.currentLanguage = check_string_type(result.configvalue);
                    result.configvalue = string_to_wrap(result.configvalue, this.currentLanguage);
                    this.modalState=  result
                }
                else{
                    this.message.error("未找到对应配置")
                }
            })
        }
        else{
            this.c_title = "新增配置"
        }
    },
};
</script>

<style scoped>
.ant-form-inline .ant-form-item{
    margin-right:40px;
}
</style>
